
    // 导出页面为PDF格式
    import html2Canvas from 'html2canvas'
    import JsPDF from 'jspdf'
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {inspectionOrderApi} from "@/api/inspection";
    import baseUrl, {uploadPage, imageUrl} from "@/constants";
    import {fileApi} from "@/api/organization";

    @Component({
        name: 'NoMatchDetail',
    })
    export default class NoMatchDetail extends Vue {
        data = {} as any //数据
        orderApplyId = "";
        loading = true;
        baseUrl = baseUrl
        fileList = [] as any
        //弹框
        dialog = {
            visible: false,
        }
        private closePage: any;
        serialNumber = "";

        created() {
            this.orderApplyId = this.$route.params.orderApplyId;
            this.getSerialNumber();
            this.listData();
        }

        packageFile() {
            if (this.data.jsonContent) {
                try {
                    const jsonContent = JSON.parse(this.data.jsonContent);
                    if (jsonContent.prove) {
                        this.fileList = [{
                            name: this.data.initiatorMechanismName + "具证.pdf",
                            url: imageUrl + jsonContent.prove
                        }];
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }

        listData() {
            inspectionOrderApi.getInspectionOrderApplyDetail({orderApplyId: this.orderApplyId}).then((res: any) => {
                if (res.data.result === 0) {
                    this.data = res.data.data;
                    this.packageFile();
                    this.loading = false;
                }
            });
        }

        getSerialNumber() {
            inspectionOrderApi.getSerialNumber({orderApplyId: this.orderApplyId}).then((res: any) => {
                if (res.data.result == 0) {
                    this.serialNumber = res.data.data;
                }
            });
        }

        getNewDate() {
            const date = new Date(); //转换成Data();
            let y = date.getFullYear();
            let m = (date.getMonth() + 1) as any;
            m = m < 10 ? '0' + m : m;
            let d = (date.getDate()) as any;
            d = d < 10 ? ('0' + d) : d;
            return y + ' 年 ' + m + ' 月 ' + d + ' 日 ';
        }

        base64ConvertFile(urlData: any, filename: string) { // 64转file
            var arr = urlData.split(',');
            var type = arr[0].match(/:(.*?);/)[1];
            var fileExt = type.split('/')[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename + "." + fileExt, {
                type: type
            });
        }

        uploadFile() {
            this.dialog.visible = true;
        }

        saveData() {
            if (this.fileList.length == 0) {
                this.$message.error("请先上传具证！");
                return;
            }
            const changeFiles = this.fileList.map((e: any) => {
                return e.url.replace(imageUrl, "");
            });
            const pdfUrl = changeFiles.join(",");
            inspectionOrderApi.updateOrderApplyProveStatus({
                orderApplyId: this.orderApplyId,
                status: 6,
                pdfUrl: pdfUrl
            }).then((res1: any) => {
                if (res1.data.result === 0) {
                    this.closeDialog();
                    this.listData();
                }
            });
        }

        closeDialog() {
            this.dialog = {visible: false};
            this.packageFile();
        }

        handleSuccess(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileList = [{name: this.data.initiatorMechanismName + "具证.pdf", url: imageUrl + rData}];
            }
        }

        handleRemove(file: any, fileList: any) {
            const index = this.fileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileList.splice(index, 1);
            }
        }

        handlePictureCardPreview(file: any) {
            window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
        }

        beforeAvatarUpload(file: any) {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                this.$message.error('上传图片只能是PDF格式!');
            }
            return (isPDF);
        }

        downFileBefore() {
            this.loading = true;
            setTimeout(() => {
                this.downFile();
            }, 1000);
        }
        DPR() { // 获取设备dpi
            if (window.devicePixelRatio && window.devicePixelRatio > 1) {
                return window.devicePixelRatio;
            }
            return 1;
        }

        downFile() {
            const a = document.querySelector('#pdfDom') as any;
            const aa = a.cloneNode(true);
            (document.querySelector("#pdfDomAll") as any).innerHTML = "";
            (document.querySelector("#pdfDomAll") as any).appendChild(aa);
            const pdfDom = this.$refs.pdfDomAll as HTMLFormElement;
            const w = pdfDom.offsetWidth;
            let h = pdfDom.offsetHeight;
            const {initiatorMechanismName} = this.data as any;
            html2Canvas(pdfDom, {
                allowTaint: true,
                useCORS: true,
                scale: 2,
                width: w,
                height: h,
            }).then((canvas) => {
                    const pdf = new JsPDF('p', 'mm', 'a4'); //A4纸，纵向
                    const ctx = canvas.getContext('2d') as any;
                    const a4w = 210;
                    const a4h = 297 //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
                    const imgHeight = Math.floor(a4h * canvas.width / a4w);
                    let renderedHeight = 70 * 2;
                    let isFirst = true;
                    while (renderedHeight < canvas.height) {
                        const page = document.createElement("canvas") as any;
                        page.width = canvas.width;
                        page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页
                        //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
                        page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas
                            .height - renderedHeight)), 0, 0);
                        if (!isFirst) {
                            pdf.addImage(page.toDataURL('image/PNG', 1.0), 'PNG', 0, 0, a4w, Math.min(a4h, a4w * page.height / page.width)); //添加图像到页面，保留10mm边距
                        } else {
                            pdf.addImage(page.toDataURL('image/PNG', 1.0), 'PNG', 0, 0, a4w, Math.min(a4h, a4w * page.height / page.width)); //添加图像到页面，保留10mm边距
                        }
                        renderedHeight += imgHeight;
                        if (renderedHeight < canvas.height)
                            pdf.addPage(); //如果后面还有内容，添加一个空页

                        isFirst = false;
                    }
                    let file = this.base64ConvertFile(pdf.output("dataurlstring"), initiatorMechanismName);
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('category', 'public')
                    fileApi.upload(formData).then((res: any) => {
                        if (res.data.result === 0) {
                            inspectionOrderApi.updateOrderApplyProveStatus({
                                orderApplyId: this.orderApplyId,
                                status: 5,
                                pdfUrl: res.data.data
                            }).then((res1: any) => {
                                if (res1.data.result === 0) {
                                    pdf.save(initiatorMechanismName + '.pdf');
                                    this.loading = false;
                                }
                            });
                        }
                    });
                }
            )
        }
    }
